// author-liumingyang 2022-3-8  经分
import React, { useState, useEffect, useRef, useMemo } from 'react';
import ReactEcharts from 'echarts-for-react';
// import { scoreFormat, initialUpperCase } from '@/utils/utils';

import { scoreFormat } from '@op/utils/value';
import { initialUpperCase, mathFormat } from '@/pages/opinion/utils';
import { useIntl, getLocale } from 'umi';
import { formatter } from '@/pages/opinion/components/ChartCommon/formatter';

export const getAvgSentimentAndColor = (sentiment) => {
  let category = 'Neutral';
  let color = '#6E7794';
  if (sentiment > 3.5) {
    category = 'Positive';
    color = '#69D19C';
  } else if (sentiment >= 2.5) {
    category = 'Neutral';
    color = '#6E7794';
  } else {
    category = 'Negative';
    color = '#F17C86';
  }

  return [category, color];
};

export default (props) => {
  const { formatMessage } = useIntl();
  const maps = {
    origin: 'word',
    zh: 'word_cn',
    en: 'word_en',
  };

  const { data, language = 'origin' } = props;

  const getSeriesData = (item) => {
    const { word, frequency, avg_sentiment } = item;

    let category = getAvgSentimentAndColor(avg_sentiment)[0];

    const newItem = {
      ...item,
      id: word,
      name: initialUpperCase(item[maps[language] || maps.origin]),
      value: frequency,
      category,
    };

    return newItem;
  };

  const option = useMemo(() => {
    let seriesData: any[] = [];
    let seriesLinks: any[] = [];

    const seriesDataMap = {};
    const frequencys: any[] = [];
    const correlations: any[] = [];

    if (data && Array.isArray(data) && data.length > 0) {
      // const maxSymbolSize = Math.max(...symbolSizeArr)
      // const minSymbolSize = Math.min(...symbolSizeArr)
      // const maxLinkSize = Math.max(...linkSizeArr)
      // const minLinkSize = Math.min(...linkSizeArr)
      // for (const index in data) {
      //   data[index].symbolSize = ((data[index].symbolSize - minSymbolSize) / (maxSymbolSize - minSymbolSize)) * 60 + 1
      // }

      for (let index = 0; index < data.length; index += 1) {
        const item = data[index];
        const { Child = [], word } = item;

        if (!seriesDataMap[word]) {
          const newItem = getSeriesData(item);
          seriesData.push(newItem);
          frequencys.push(newItem.value);
          seriesDataMap[word] = 1;
        } else {
          seriesDataMap[word] += 1;
        }

        if (Child && Array.isArray(Child) && Child.length > 0) {
          for (let index2 = 0; index2 < Child.length; index2 += 1) {
            const child = Child[index2];
            if (!seriesDataMap[child.word]) {
              const newItem = getSeriesData(child);
              seriesData.push(newItem);
              frequencys.push(newItem.value);
              correlations.push(Math.log(newItem.correlation));
              seriesDataMap[child.word] = 1;
            } else {
              seriesDataMap[child.word] += 1;
            }
            seriesLinks.push({
              source: word,
              target: child.word,
              value: child.correlation,
              lineStyle: {
                width: Math.log(child.correlation),
                color: getAvgSentimentAndColor(child.avg_sentiment)[1],
              },
              avg_sentiment: child.avg_sentiment,
              count: child.count,
              originSource: item,
              originTarget: child,
            });
          }
        }
      }
    }

    const maxFrequency = Math.max(...frequencys);
    const minFrequency = Math.min(...frequencys);
    const maxCorrelation = Math.max(...correlations);
    const minCorrelation = Math.min(...correlations);

    for (const index in seriesData) {
      seriesData[index].symbolSize =
        ((seriesData[index].value - minFrequency) /
          (maxFrequency - minFrequency)) *
          60 +
        5;
    }
    for (const index in seriesLinks) {
      try {
        seriesLinks[index].lineStyle.width =
          ((seriesLinks[index].lineStyle.width - minCorrelation) /
            (maxCorrelation - minCorrelation)) *
            5 +
          1;
      } catch (err) {
        console.log(
          'seriesLinks[index] err',
          err,
          seriesLinks[index],
          seriesLinks[index].lineStyle,
        );
      }
    }

    // console.log(seriesDataMap, seriesData, seriesLinks, frequencys, correlations);

    const option = {
      tooltip: {
        trigger: 'item',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        borderWidth: 0,
        borderRadius: 6,
        padding: 0,
        formatter: (param) => {
          console.log(param);
          const { name, data = {}, dataType = 'node' } = param;
          const {
            frequency = 0,
            avg_sentiment = 0,
            value = 0,
            count = 0,
            originSource = {},
            originTarget = {},
          } = data;

          let title = name;

          if (dataType === 'edge') {
            const sourceName = initialUpperCase(
              originSource[maps[language] || maps.origin],
            );
            const targetName = initialUpperCase(
              originTarget[maps[language] || maps.origin],
            );

            title = `${initialUpperCase(sourceName)}, ${initialUpperCase(
              targetName,
            )}`;
          }

          let records: any[] = [];

          if (dataType === 'edge') {
            records = [
              {
                key: formatMessage({ id: 'Correlation' }),
                value: value === 0 ? '-' : value?.toFixed(2),
              },
              {
                key: formatMessage({ id: 'Sentiment' }),
                value: avg_sentiment === 0 ? '-' : avg_sentiment?.toFixed(2),
              },
              {
                key: formatMessage({ id: 'Mentions' }),
                value: mathFormat(count),
              },
            ];
          } else {
            records = [
              {
                key: formatMessage({
                  id: 'Frequency',
                }),
                value: scoreFormat(frequency),
              },
              {
                key: formatMessage({
                  id: 'Sentiment',
                }),
                value: avg_sentiment === 0 ? '-' : avg_sentiment?.toFixed(2),
              },
              {
                key: formatMessage({
                  id: 'Mentions',
                }),
                value: mathFormat(count),
              },
            ];
          }

          return formatter({
            title,

            tables: [
              {
                showHeader: false,
                records,
                columns: [
                  {
                    key: 'key',
                  },
                  {
                    key: 'value',
                    align: 'right',
                    weight: 'bold',
                  },
                ],
              },
            ],
          });
        },
      },
      color: ['#69D19C', '#6E7794', '#F17C86'],
      legend: {
        itemWidth: 8,
        itemHeight: 8,
        icon: 'circle',
        bottom: 0,
        data: ['Positive', 'Neutral', 'Negative'],
        backgroundColor: '#fff',
        textStyle: {
          //图例文字的样式
          color: '#888888',
          fontSize: 12,
          lineHeight: 16,
        },
        // 使用回调函数
        formatter: function (name: string) {
          return formatMessage({ id: name });
        },
      },
      animationDuration: 1500,
      animationEasingUpdate: 'quinticInOut',
      series: [
        {
          zoom: props.zoom || 1.5,
          draggable: true,
          type: 'graph',
          layout: 'force',
          force: {
            repulsion: 100,
            edgeLength: 30,
            gravity: 0.1,
            friction: 0.6,
          },
          label: {
            show: true,
            position: 'right',
          },
          roam: true,
          lineStyle: {
            color: 'source',
            curveness: 0.3,
          },
          emphasis: {
            focus: 'adjacency',
          },
          blur: {
            label: { show: false },
            itemStyle: {
              opacity: 0.4,
            },
            lineStyle: {
              opacity: 0.3,
            },
          },
          scaleLimit: {
            min: 1,
            max: 3,
          },
          data: seriesData,
          links: seriesLinks,
          categories: [
            {
              name: 'Positive',
            },
            {
              name: 'Neutral',
            },
            {
              name: 'Negative',
            },
          ],
        },
      ],
    };

    return option;
  }, [data, language, getLocale()]);

  return (
    <ReactEcharts
      style={{ height: props.height || 300, width: '100%' }}
      option={option}
      lazyUpdate={true}
      notMerge={true}
    />
  );
};
